import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function YesNoProperties({ question }) {
  return <QuestionLabel question={question} />
}